import React from "react";
import EditableSection from "./EditableSection";

const CreditWorthy = ({ lead, onSave }) => {
  return (
    <EditableSection
      title="📊 Credit Worthy"
      data={{
        credit_score: lead?.credit_score,
        existing_emis: lead?.existing_emis,
        emi_selected: lead?.emi_selected,
        tenure_selected: lead?.tenure_selected,
      }}
      fields={[
        { name: "credit_score", label: "Credit Score" },
        { name: "existing_emis", label: "Existing EMIs" },
        { name: "emi_selected", label: "Recommended EMI" },
        { name: "tenure_selected", label: "Tenure (months)" },
      ]}
      onSave={onSave}
    />
  );
};

export default CreditWorthy;